import router from './router'
import useSearchStore from './store'
import SearchMessages from './localization'

export default {
  router,
  store: useSearchStore,
  localization: SearchMessages,
}
